import { render, staticRenderFns } from "./MonitorIndex.vue?vue&type=template&id=a8fd282c&scoped=true&"
import script from "./MonitorIndex.vue?vue&type=script&lang=ts&"
export * from "./MonitorIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fd282c",
  null
  
)

export default component.exports